<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Statistics Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.statsType }}</td>
          <td class="text-xs-left">{{ props.item.statsTypeDesc }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.mtrRiskFact) }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.pkgRiskFact) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" query review @query="doQuery" @review="doReview"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <div class="pt-2">
      <v-btn color="primary" @click.native="doNewProduct">
        New Statistics Type
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      headers: [
        { text: 'Statistics Type Code', value: 'statsType' },
        { text: 'Statistics Type Description', value: 'statsTypeDesc' },
        { text: 'Motor Risk Factor', value: 'mtrRiskFact' },
        { text: 'Package Risk Factor', value: 'pkgRiskFact' },
        TableConst.tableActionHeader
      ]
    }
  },
  computed: {
    statistics() {
      return this.$store.state.parameters.statistics
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.statistics.menu.StatsTypes
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((stats) => {
              const convertStats = {
                statsType: stats.statsType,
                statsTypeDesc: stats.statsTypeDesc,
                mtrRiskFact: stats.mtrRiskFact,
                pkgRiskFact: stats.pkgRiskFact
              }
              this.items.push(convertStats)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    doQuery(data) {
      if (data && data.item) {
        this.$router.push({ name: 'statsQuery', params: { id: data.item.statsType } })
      }
    },
    doReview(data) {
      if (data && data.item) {
        this.$router.push({ name: 'statsReview', params: { id: data.item.statsType } })
      }
    },
    doNewProduct() {
      this.$router.push({ name: 'statsReview', params: { id: 'new' } })
    }
  },
  mounted() {
    this.init()
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style>

</style>
